import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { flattenRoutes } from "./flattenRoutes";

const flatRoutes = flattenRoutes(AppRoutes);

function usePageTitle() {
    const location = useLocation();

    useEffect(() => {
        let newTitle = "AccuRate Enterprise"; //default

        for (const route of flatRoutes) {
            if ((route.path && matchPath({ path: route.path, end: false }, location.pathname)) ||
                (route.index && location.pathname === "/")) {
                if (route.title) {
                    newTitle = route.title;
                }
                break;
            }
        }

        document.title = newTitle;
    }, [location]);
}

export default usePageTitle;